'use client';

import { getSessionId } from '@shared/tracking';
import { getCookie } from '@shared/utils';

type NavigatorWithUAData = Navigator & {
  userAgentData?: {
    platform?: string;
  };
};

const getNavigatorPlatform = () => {
  if (typeof window === 'undefined' || !window.navigator) return undefined;
  const navigatorWithUAData = window.navigator as NavigatorWithUAData;
  return navigatorWithUAData.userAgentData?.platform;
};

function buildFeedbackContext(locale: string) {
  return {
    locale,
    platform: getNavigatorPlatform(),
    user_agent: typeof window !== 'undefined' && window.navigator?.userAgent ? window.navigator.userAgent : 'unknown',
    page_url: typeof window !== 'undefined' && window.location?.href ? window.location.href : '',
    session_id: getSessionId(),
    experiment_variant: getCookie('experimentVariation') || '',
  };
}

export { buildFeedbackContext };
